export type ConditionStatus = 'Baik' | 'Rusak Ringan' | 'Rusak Berat';

export interface ClassInventoryItem {
  id: string;
  name: string;
  quantity: number;
  condition: ConditionStatus;
  notes: string;
}

export interface ClassRoomFacility {
  id: string;
  name: string;
  condition: ConditionStatus;
  notes: string;
}

export interface ClassCleanlinessActivity {
  id: string;
  activity: string;
  scheduleOrPerson: string;
}

export const DEFAULT_INVENTORY_ITEMS: Omit<ClassInventoryItem, 'id'>[] = [
  { name: 'Lambang Garuda', quantity: 1, condition: 'Baik', notes: 'Terpasang di dinding depan atas' },
  { name: 'Gambar Presiden', quantity: 1, condition: 'Baik', notes: 'Terpasang di sebelah kanan Garuda' },
  { name: 'Gambar Wakil Presiden', quantity: 1, condition: 'Baik', notes: 'Terpasang di sebelah kiri Garuda' },
  { name: 'Meja Siswa', quantity: 16, condition: 'Baik', notes: 'Kondisi kokoh & rapi' },
  { name: 'Kursi Siswa', quantity: 32, condition: 'Baik', notes: 'Lengkap dan layak pakai' },
  { name: 'Meja Guru', quantity: 1, condition: 'Baik', notes: 'Rapi dengan taplak meja' },
  { name: 'Kursi Guru', quantity: 1, condition: 'Baik', notes: 'Kondisi baik' },
  { name: 'Papan Tulis (Whiteboard)', quantity: 1, condition: 'Baik', notes: 'Bersih & siap pakai' },
  { name: 'Penghapus Papan Tulis', quantity: 2, condition: 'Baik', notes: 'Tersedia di meja guru' },
  { name: 'Papan Absensi / Data Kelas', quantity: 1, condition: 'Baik', notes: 'Terisi update bulanan' },
  { name: 'Komputer / Laptop Kelas', quantity: 1, condition: 'Baik', notes: 'Berfungsi normal' },
  { name: 'Lemari Kelas', quantity: 1, condition: 'Baik', notes: 'Tempat buku & arsip kelas' },
  { name: 'Perangkat Kebersihan (Sapu, Pel, Tong Sampah, Kemoceng)', quantity: 1, condition: 'Baik', notes: 'Lengkap di sudut belakang kelas' },
  { name: 'Jam Dinding', quantity: 1, condition: 'Baik', notes: 'Berfungsi tepat waktu' },
  { name: 'Kipas Angin / Ventilasi', quantity: 2, condition: 'Baik', notes: 'Berputar normal' },
  { name: 'Bendera Merah Putih & Tiang', quantity: 1, condition: 'Baik', notes: 'Tersedia di sudut depan' }
];

export const DEFAULT_ROOM_FACILITIES: Omit<ClassRoomFacility, 'id'>[] = [
  { name: 'Lantai Ruangan', condition: 'Baik', notes: 'Keramik bersih, tidak ada yang pecah' },
  { name: 'Langit-langit (Plafon)', condition: 'Baik', notes: 'Rapi & tidak bocor' },
  { name: 'Atap / Genting', condition: 'Baik', notes: 'Kondisi kokoh & aman saat hujan' },
  { name: 'Pintu Kelas', condition: 'Baik', notes: 'Engsel dan kunci berfungsi baik' },
  { name: 'Jendela & Ventilasi', condition: 'Baik', notes: 'Kaca utuh, ventilasi udara lancar' },
  { name: 'Teras Depan Kelas', condition: 'Baik', notes: 'Bersih dan tertata rapi' },
  { name: 'Sarana Listrik (Stopkontak & Saklar)', condition: 'Baik', notes: 'Aman dan berfungsi normal' },
  { name: 'Lampu Penerangan', condition: 'Baik', notes: 'Menyala terang, tidak ada yang redup' },
  { name: 'Dinding / Tembok Kelas', condition: 'Baik', notes: 'Cat bersih, tidak ada coretan' }
];

export const DEFAULT_CLEANLINESS_ACTIVITIES: Omit<ClassCleanlinessActivity, 'id'>[] = [
  {
    activity: 'Pelaksanaan regu piket harian peserta didik (menyapu, mengepel lantai, membersihkan papan tulis, dan membuang sampah ke TPS).',
    scheduleOrPerson: 'Setiap Hari (Pagi & Pulang Sekolah) / Regu Piket Siswa'
  },
  {
    activity: 'Gerakan Jumat / Sabtu Bersih (pembersihan massal jendela kaca, debu ventilasi, sawang plafon, dan sudut kelas).',
    scheduleOrPerson: 'Mingguan (Setiap Jumat/Sabtu) / Seluruh Warga Kelas'
  },
  {
    activity: 'Penataan dan pemeliharaan Sudut Baca / Pojok Literasi serta papan mading kreasi peserta didik.',
    scheduleOrPerson: 'Berkala / Seksi Literasi & Pengurus Kelas'
  },
  {
    activity: 'Pemeliharaan dan penyiraman tanaman hias serta pot bunga di teras depan ruang kelas.',
    scheduleOrPerson: 'Setiap Hari / Petugas Piket Teras'
  },
  {
    activity: 'Pengecekan kerapian susunan meja-kursi siswa dan meja guru sebelum serta sesudah jam KBM.',
    scheduleOrPerson: 'Setiap Pergantian Jam / Ketua & Wakil Ketua Kelas'
  },
  {
    activity: 'Pemilahan sampah organik dan anorganik pada tempat sampah di dalam serta luar kelas.',
    scheduleOrPerson: 'Setiap Hari / Seluruh Siswa'
  }
];
